import { useContext, useEffect, useState } from "react";
import { useStylesMainPage } from "../styles/MainPageStyle";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AdminUserService,
  KS_customerservice_Service_Models_AdminUserDtos_AdminUserDto,
} from "../CustomerSvcService";
import TableComponent from "../components/table/TableComponent";
import { TABLE, TOAST } from "../utils/Enums";
import { Button, useToastController } from "@fluentui/react-components";
import { notify } from "../utils/DispatchToaster";
import { ToasterContext } from "../utils/GlobalContexts";

export default function TenantByUserPage() {
  const styles = useStylesMainPage();
  const location = useLocation();
  const id = location.state.id;
  const [userDataPointInfo, setUserDataPointInfo] =
    useState<KS_customerservice_Service_Models_AdminUserDtos_AdminUserDto | null>();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { toasterId } = useContext(ToasterContext);
  const { dispatchToast } = useToastController(toasterId);

  const navigateBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const getData = async () => {
    if (id) setIsLoading(true);
    await AdminUserService.getApiAdminUser(id)
      .then((res) => {
        if (res) {
          setUserDataPointInfo(res);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        notify(TOAST.ERROR, "Nem sikerült az adatok betöltése", dispatchToast);
        setIsLoading(false);
      });
  };

  return (
    <div className={styles.main}>
      <div className={styles.backButton}>
        <Button onClick={navigateBack}>Vissza</Button>
        <div
          className={styles.pageText}
        >{`${id} felhaszálóhoz tartozó tenantok`}</div>
      </div>
      <TableComponent
        type={TABLE.ADATPONT_TENANTS}
        data={userDataPointInfo?.tenants}
        isLoading={isLoading}
        oid={id}
      />
    </div>
  );
}
